import { render } from "./CoDiver.vue?vue&type=template&id=2e69fdbe&scoped=true"
import script from "./CoDiver.vue?vue&type=script&lang=js"
export * from "./CoDiver.vue?vue&type=script&lang=js"

import "./CoDiver.vue?vue&type=style&index=0&id=2e69fdbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e69fdbe"]])

export default __exports__